import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import SmoothScrollProvider from './providers/SmoothScrollProvider.tsx'
import './index.css'
import './styles/animations.css'

createRoot(document.getElementById("root")!).render(
  <SmoothScrollProvider>
    <App />
  </SmoothScrollProvider>
);
